import { apiClient } from '@lib/api-client';
import { TMutationConfig } from '@lib/react-query';
import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/* API                                    */
/* -------------------------------------------------------------------------- */

export const verifyBrand = ({
	id,
	legalIdentifier,
}: {
	id: string | number;
	legalIdentifier: string;
}): Promise<any> => {
	return apiClient.patch(`/brands/verify/${id}`, {
		legalIdentifier,
	});
};

/* -------------------------------------------------------------------------- */
/* Hook                                    */
/* -------------------------------------------------------------------------- */

type TUseVerifyBrandOptions = {
	mutationConfig?: TMutationConfig<typeof verifyBrand>;
};

export const useVerifyBrand = ({
	mutationConfig,
}: TUseVerifyBrandOptions = {}) => {
	const { onSuccess, ...restConfig } =
		mutationConfig || {};
	const { t } = useTranslation();

	return useMutation({
		mutationFn: verifyBrand,
		onSuccess: (...args) => {
			onSuccess?.(...args);
		},
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'var(--mantine-color-igluRed-9)',
			});
		},
		...restConfig,
	});
};
